import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f3cd83c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Geocoder" }
const _hoisted_2 = { class: "mt-3 flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none font-semibold" }, "Указанный адрес:", -1))
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "mt-1 flex text-sm flex-col" }
const _hoisted_7 = { class: "block select-none" }
const _hoisted_8 = { class: "block select-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_geocoder = _resolveComponent("map-geocoder")!
  const _component_the_map = _resolveComponent("the-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_the_map, {
      class: "without-padding without-border",
      "is-can-hide": false,
      onMapReady: _ctx.onMapReady,
      onMapChange: _ctx.onMapLayerChange
    }, {
      default: _withCtx(() => [
        (_ctx.state.is_city_setted)
          ? (_openBlock(), _createBlock(_component_map_geocoder, {
              key: 0,
              "twogis-geocoder": _ctx.isTwoGis,
              "yandex-geocoder": _ctx.isYandex,
              "city-name": _ctx.cityName,
              bbox: _ctx.bbox,
              onSelect: _ctx.onSelectAddress
            }, null, 8, ["twogis-geocoder", "yandex-geocoder", "city-name", "bbox", "onSelect"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onMapReady", "onMapChange"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        (_ctx.state.is_geocoding)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Геокодирование адреса... ")
            ], 64))
          : (_ctx.state.is_geocoding_failed)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Ошибка геокодирования ")
              ], 64))
            : (!Boolean(_ctx.state.geocoded_address))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" Укажите адрес ")
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.state.geocoded_address), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, "Долгота: " + _toDisplayString(_ctx.state.geocoded_latitude), 1),
      _createElementVNode("span", _hoisted_8, "Широта: " + _toDisplayString(_ctx.state.geocoded_longitude), 1)
    ])
  ]))
}